import { ApiError } from '../api.js'

const SAFE_NAME = /^[^\\/:*?"<>|\u0000-\u001f]{1,160}$/

export async function downloadReportExport({
  path,
  values,
  mediaType,
  extension,
  fallbackName = 'report',
  fetchImpl = fetch,
  documentRef = document,
  urlApi = URL,
}) {
  const response = await fetchImpl(`/api${path}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ values }),
  })
  if (!response.ok) {
    const payload = await response.json().catch(() => null)
    throw new ApiError(payload?.error?.message ?? 'Export failed', response.status,
      payload?.error?.code, payload?.correlationId)
  }
  const actualType = (response.headers.get('content-type') ?? '').toLowerCase().split(';')[0].trim()
  if (actualType !== mediaType.toLowerCase()) {
    throw new ApiError('Unexpected export content type', 502, 'invalid_export_content_type')
  }
  const filename = responseFileName(response.headers.get('content-disposition'), extension, fallbackName)
  const blob = await response.blob()
  const objectUrl = urlApi.createObjectURL(blob)
  try {
    const link = documentRef.createElement('a')
    link.href = objectUrl
    link.download = filename
    link.rel = 'noopener'
    link.style.display = 'none'
    documentRef.body.append(link)
    link.click()
    link.remove()
  } finally {
    urlApi.revokeObjectURL(objectUrl)
  }
  return filename
}

export function responseFileName(disposition, extension, fallbackName = 'report') {
  if (!/^\.[a-z0-9]{1,8}$/.test(extension)) throw new Error('Invalid export extension')
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition ?? '')?.[1]
  const quoted = /filename="([^"]+)"/i.exec(disposition ?? '')?.[1]
  let candidate = encoded ? safeDecode(encoded) : quoted
  if (!disposition?.toLowerCase().startsWith('attachment;')
      || !candidate?.toLowerCase().endsWith(extension) || !SAFE_NAME.test(candidate)) {
    candidate = `${safeFallback(fallbackName)}${extension}`
  }
  return candidate
}

function safeDecode(value) {
  try {
    return decodeURIComponent(value)
  } catch {
    return ''
  }
}

function safeFallback(value) {
  const name = String(value ?? '').replace(/[\\/:*?"<>|\u0000-\u001f]/g, '_').trim().slice(0, 120)
  return name || 'report'
}
